// Title: replace-search-placeholder.ts
//
// Author: Jacco van der Post <vanderpost@redkiwi.nl>
//
// Date: 22-03-2022
//

/**
 * Replace header search box placeholder text on mobile
 * Use label then (Search vs What are you looking for?)
 */
export class ReplaceSearchPlaceholder {
    constructor() {
        const element = document.querySelector("body > header > .container");

        if (!element) {
            return;
        }

        const containerWidth = element.clientWidth;

        if (containerWidth < 1023) {
            const label = document.getElementById(
                "header-search-label"
            )?.textContent;

            const input = document.getElementById(
                "header-search"
            ) as HTMLElement;

            if (input && label) {
              input.placeholder = label;
            }
        }
    }
}
